export default __webpack_public_path__ + "static/media/DSC01941-scaled.6e8186f6.jpeg";